import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../services/data.service';

interface ModuleInfo {
	id: number;
	category: string;
	module: string;
	description: string;
	users: number;
	enabled: boolean;
}

@Component({
	selector: 'app-pkg-master',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule
	],
	templateUrl: './pkg-master.component.html',
	styleUrl: './pkg-master.component.scss',
})
export class PkgMasterComponent {
	search = '';
	category = 'All';
	loading = false;
	isEdit = false;
	allModules: any = [];

	plan = {
		packageName: 'Customized',
		organization: 'ABC International School',
		planType: 'Yearly',
		licenseKey: 'ERP-7865-ABCD-5678',
		activatedOn: '01-Apr-2026',
		expiry: '31-Mar-2027',
		status: 'Active',
		amount: '₹59,999',
		maxUsers: 500,
		usedUsers: 287,
		storage: 250,
		usedStorage: 122,
		schools: 5,
		usedSchools: 2
	};

	categories: any = [];

	modules: ModuleInfo[] = [
		// { id: 1, category: 'Academic', module: 'Student Management', description: 'Student Admission & Profile', users: 287, enabled: true },
		// { id: 2, category: 'Academic', module: 'Attendance', description: 'Daily Attendance', users: 240, enabled: true },
		// { id: 3, category: 'Academic', module: 'Time Table', description: 'Schedule Management', users: 90, enabled: true },
		// { id: 4, category: 'Finance', module: 'Fee Management', description: 'Fee Collection', users: 20, enabled: true },
		// { id: 5, category: 'Finance', module: 'Accounting', description: 'Accounts & Ledger', users: 5, enabled: true },
		// { id: 6, category: 'HR', module: 'Payroll', description: 'Salary Processing', users: 12, enabled: true },
		// { id: 7, category: 'Transport', module: 'Transport', description: 'Vehicle Management', users: 6, enabled: false },
		// { id: 8, category: 'Library', module: 'Library', description: 'Books Management', users: 35, enabled: true },
		// { id: 9, category: 'Hostel', module: 'Hostel', description: 'Hostel Management', users: 0, enabled: false },
		// { id: 10, category: 'Communication', module: 'SMS & Email', description: 'Communication Center', users: 8, enabled: true },
		// { id: 11, category: 'Examination', module: 'Examination', description: 'Exam & Results', users: 75, enabled: true }
	];

	get filteredModules() {
		return this.modules.filter(x => {
			const s = x.module.toLowerCase().includes(this.search.toLowerCase());
			const c = this.category == 'All' || x.category == this.category;
			return s && c;
		});
	}

	get activeModules() {
		return this.modules.filter(x => x.enabled).length;
	}

	get inactiveModules() {
		return this.modules.filter(x => !x.enabled).length;
	}

  constructor(public dataService: DataService) {
    //
  }

  ngOnInit() {
		this.categories = this.dataService.departments;
		this.loading = true;
    this.dataService.getAllRecords('modules').then((res: any) => {
      this.allModules = res;
			for(let i=0; i<res.length; i++) {
				this.modules.push(
					{ 'id': i, 'category': res[i].dept_name || 'xxxxxxxxxx', 'module': res[i].m_name, 'description': res[i].description, 'users': 0, 'enabled': res[0].is_active }
				);
			}

      this.loading = false;
    });

		// this.loading = true;
    // this.dataService.getAllRecords('organizations').then((res: any) => {
    //   this.orgs = res;
    //   this.loading = false;
    // });

    // Listen to changes continuously
    // this.dataService.outerAction.subscribe((value: any) => {
    //   if (value) {
    //     // this.action = value.action;

    //     if (value.data) {
    //       // this.frmData = value.data;
    //     } else {
    //       // this.resetForm();
    //     }
    //     this.dataService.updateOuterAction(null);
    //   }
    // });
  }

}